import React, { useState, useRef } from 'react';
import { Button, Table, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { CSSTransition } from 'react-transition-group';

import { criteria, criteria_tooltips, default_tooltip_show, default_tooltip_hide } from '../Consts';

import './Evaluation.css';

const EvaluationPerformSingleTableCollapsible = ({ parentState, evalData }) => {
    const [openTb, setOpenTb] = useState(false);
    const [openCp, setOpenCp] = useState(false);

    const nodeRefTb = useRef(null);
    const nodeRefCp = useRef(null);
    const nodeRefs = useRef([]);

    const ed = evalData;
    const data = ed[0];
    const exam = ed[1];

    return (
        <>
            <div className="pb-3">
                <Button
                    variant="outline-primary"
                    size="sm"
                    className="p-1 no-print"
                    onClick={() => setOpenTb(!openTb)}
                    aria-controls="collapseTable"
                    aria-expanded={openTb}
                >
                    {openTb ? "Detailansicht ausblenden" : "Detailansicht einblenden"}
                </Button>

                <CSSTransition
                    nodeRef={nodeRefTb}
                    in={openTb}
                    timeout={750}
                    classNames="details-table"
                    unmountOnExit
                >
                    <Table ref={nodeRefTb} bordered hover responsive="md" className="" id="singleEvalTable">
                        <tbody>

                            {/* crossproduct */}
                            {parentState.criterion_b === "yes" &&
                                <>
                                    <tr>
                                        <td colSpan={data.numTasks + 1} className="m-0 p-0">
                                            <Button
                                                variant="link"
                                                size="sm"
                                                className="p-1 m-0"
                                                onClick={() => setOpenCp(!openCp)}
                                                aria-controls="collapseCp"
                                                aria-expanded={openCp}
                                            >
                                                {openCp && "Abweichung bei " + criteria[1] + " ausblenden"}
                                                {!openCp && "Abweichung bei " + criteria[1] + " einblenden"}
                                            </Button>
                                        </td>
                                        <td colSpan={2} className="border-0"></td>
                                    </tr>

                                    <CSSTransition
                                        key="cp-table-header"
                                        nodeRef={nodeRefCp}
                                        timeout={500}
                                        in={openCp}
                                        classNames="details-table"
                                        unmountOnExit
                                    >
                                        <tr ref={nodeRefCp}>
                                            <td>&nbsp;</td>
                                            {exam.taskNames[0].slice(2).map((aufgabe, index) => (
                                                <td key={index} className="text-center">{aufgabe.value}</td>
                                            ))}
                                            <td colSpan={2} className="border-0"></td>
                                        </tr>
                                    </CSSTransition>

                                    {Object.keys(data.crossProducts).map((key, index) => {
                                        return (
                                            nodeRefs.current[index] = React.createRef(),
                                            <CSSTransition
                                                key={`cp-table-row-${index}`}
                                                nodeRef={nodeRefs.current[index]}
                                                timeout={500}
                                                in={openCp}
                                                classNames="details-table"
                                                unmountOnExit
                                            >

                                                <tr ref={nodeRefs.current[index]} key={index}>
                                                    {data.crossProducts[key].map((item, index) => (
                                                        <React.Fragment key={index}>
                                                            {index === 0 ? (
                                                                <td key={index} className="text-center">{item}</td>
                                                            ) : item > 40 ? (
                                                                <OverlayTrigger
                                                                    key={`overlay-${index}`}
                                                                    delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                                                    overlay={
                                                                        <Tooltip id={`tooltip-${index}`} className="eval-critB-tooltip">
                                                                            {criteria_tooltips[1]}
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <td key={`td-${index}`} className="pointerHelp text-center fw-bold colorCritBBG">{item}%</td>
                                                                </OverlayTrigger>
                                                            ) : (
                                                                <td key={index}>&nbsp;</td>
                                                            )}
                                                        </React.Fragment>
                                                    ))}
                                                    <td colSpan={2} className="border-0"></td>
                                                </tr>
                                            </CSSTransition>
                                        )
                                    })}

                                    <CSSTransition
                                        key="cp-table-bottom"
                                        nodeRef={nodeRefs.current[nodeRefs.current.length]}
                                        timeout={500}
                                        in={openCp}
                                        classNames="details-table"
                                        unmountOnExit
                                    >
                                        <tr ref={nodeRefs.current[nodeRefs.current.length]} ><td colSpan={data.numTasks + 3} className='emptyTableRow'
                                            style={{ backgroundColor: "white" }}>&nbsp;</td></tr>
                                    </CSSTransition>
                                </>
                            }

                            <tr>
                                <td className="text-center border-0 fw-bold">Stufe</td>
                                {exam.abereiche[0].slice(2).map((abereich, index) => (
                                    <td key={index} className="text-center border-0">{abereich.value}</td>
                                ))}
                                <td colSpan="2" className="border-0"></td>
                            </tr>

                            <tr>
                                <td className="text-center fw-bold">Aufgaben</td>
                                {exam.taskNames[0].slice(2,).map((aufgabe, index) => {
                                    return (
                                        <td key={index} className="text-center">{aufgabe.value}</td>
                                    );
                                })}

                                <td className="text-center fw-bold">Summe</td>
                                <td className="border-0"></td>
                            </tr>

                            <tr>
                                <td className="text-center fw-bold">Punkte</td>
                                {exam.maxPunkte[0].slice(2,).map((punkte, index) => {
                                    return (
                                        <td key={index} className="text-center">{punkte.value}</td>
                                    );
                                })}
                                <td className="border-0"></td>
                            </tr>

                            <tr>
                                <td colSpan={data.numTasks + 3} className="text-center fs-5"><span className="fw-bold">{exam.klasse}</span>_{exam.fach}_{exam.schuljahr}</td>
                            </tr>

                            <tr>
                                <td className="text-center fw-bold">L&ouml;sungsgrad</td>
                                {data.aDegOfSolution.map((degree, index) => (
                                    <React.Fragment key={index}>
                                        {(degree > 80 || degree < 20) ? (
                                            <OverlayTrigger
                                                key={`overlay-${index}`}
                                                delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                                overlay={
                                                    <Tooltip id={`tooltip-degree-${index}`} className="eval-critA-tooltip">
                                                        {criteria_tooltips[0]}
                                                    </Tooltip>
                                                }
                                            >
                                                <td key={`td-${index}`} className="bold pointerHelp colorCritABG text-center text-white">{degree}%</td>
                                            </OverlayTrigger>
                                        ) : (
                                            <td key={index} className="text-center">{degree}%</td>
                                        )}
                                    </React.Fragment>
                                ))}

                                <td></td>
                                <td className="text-center fw-bold">Ergebnis</td>
                            </tr>

                            <tr>
                                <td className="text-center fw-bold">Mittelwert</td>
                                {data.aAverage.map((avg, index) => {
                                    return (
                                        <td key={index} className="text-center">{avg}</td>
                                    );
                                })}
                                <td className="text-center">{data.sumAverage}</td>
                                <td className="text-center">{data.percentageAverage}%</td>
                            </tr>

                            <tr>
                                <td className="text-center fw-bold">Max</td>

                                {data.aMaxVals.map((max, index) => (
                                    <React.Fragment key={index}>
                                        {max < exam.maxPunkte[0][index + 2].value ? (
                                            <OverlayTrigger
                                                key={`overlay-${index}`}
                                                delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                                overlay={
                                                    <Tooltip id={`tooltip-max-${index}`} className="eval-maxpoints-pupil-tooltip">
                                                        Bei dieser Aufgabe wurde die volle Punktzahl nicht erreicht.
                                                    </Tooltip>
                                                }
                                            >
                                                <td key={`td-max-${index}`} className="bgBlue text-center pointerHelp">{max}</td>
                                            </OverlayTrigger>
                                        ) : (
                                            <td key={`td-max-${index}`} className="text-center">{max}</td>
                                        )}
                                    </React.Fragment>
                                ))}

                                {data.maxValPupil < data.maxPoints ? (
                                    <OverlayTrigger
                                        delay={{ show: default_tooltip_show, hide: default_tooltip_hide }}
                                        overlay={
                                            <Tooltip id="tooltip-maxValPupil" className="eval-maxpoints-pupil-tooltip">
                                                Die maximale Punktzahl der Klassenarbeit wurde nicht erreicht.
                                            </Tooltip>
                                        }
                                    >
                                        <td key="td-maxValPupil" className="text-center bgBlue pointerHelp">{data.maxValPupil}</td>
                                    </OverlayTrigger>
                                ) : (
                                    <td key="td-maxValPupil" className="text-center">{data.maxValPupil}</td>
                                )}

                                <td className="text-center">{data.percentageMaxVals}%</td>
                            </tr>
                        </tbody>
                    </Table>
                </CSSTransition>
            </div>
        </>
    );
};

export default EvaluationPerformSingleTableCollapsible;
